import { useState } from 'react';
import * as Yup from 'yup';
import { Card, TextField } from 'vopay';
import { Title, Button } from 'UI';
import { useTranslation, Trans } from 'react-i18next';
import PersonAddAltIcon from '../SuperAdmins/person_add_alt.svg';
import styles from './AddApproverDialog.module.scss';

const emailSchema = Yup.string().email().required();

type AddApproverDialogProps = {
  onConfirm: (email: string) => void;
  onCancel: () => void;
};

export default function AddApproverDialog({ onConfirm, onCancel }: AddApproverDialogProps) {
  const { t } = useTranslation('translations', {
    keyPrefix: 'TransactionApproval.Configuration.Roles.Approvers.AddDialog',
  });
  const [email, setEmail] = useState('');
  const isValid = emailSchema.isValidSync(email);

  return (
    <Card hoverEffect={false} className={styles.card}>
      <div className={styles.iconWrapper}>
        <img src={PersonAddAltIcon} alt="" width={60} height={60} />
      </div>

      <Title level="4" className={styles.title}>
        {t('title', { defaultValue: 'Add Approver' })}
      </Title>

      <p className={styles.description}>
        <Trans
          t={t}
          i18nKey="description"
          defaults="This action will add a new user with <bold>Approve Transactions</bold> permission only."
          components={{ bold: <strong /> }}
        />
      </p>

      <div className={styles.inputWrapper}>
        <TextField
          variant="outlineShadow"
          name="email"
          placeholder={t('inputPlaceholder', { defaultValue: 'Enter email' })}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && isValid) onConfirm(email);
          }}
        />
      </div>

      <div className={styles.buttonGroup}>
        <div>
          <Button colorScheme="secondary" size="small" onClick={onCancel} style={{ width: '100%' }}>
            {t('cancelButton', { defaultValue: 'Cancel' })}
          </Button>
        </div>
        <div>
          <Button
            colorScheme="primary"
            size="small"
            disabled={!isValid}
            onClick={() => onConfirm(email)}
            style={{ width: '100%' }}
          >
            {t('addButton', { defaultValue: 'Add Approver' })}
          </Button>
        </div>
      </div>
    </Card>
  );
}
